import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './MeetingModal.module.scss';
import { ReactComponent as BlackBackIcon } from "assets/blackBack.svg";
import { ReactComponent as IdentificationCardIcon } from "assets/identificationCard.svg";
import { ReactComponent as NavigationArrowIcon } from "assets/navigationArrowRight.svg";
import { ReactComponent as CloseIcon } from "assets/close.svg";
import { ReactComponent as AlarmIcon } from "assets/alarm.svg";
import { ReactComponent as BlueAlarmIcon } from "assets/blueAlarm.svg";
import StartTimeModal from '../StartTimeModal';
import DurationModal from '../DurationModal';
import Button from "components/Button/Button";
import { store } from "stores/Store";
import BaseballCard, { Tab } from 'Modules/PractitionerBaseballCard';
import useWindowSize from 'hooks/useWindowSize';
import { getLeadStateByPractitioner } from 'helpers/lead';

interface IMeetingModalProps {
  isOpen: boolean;
  practitioner: any;
  onClose: () => void;
  updatePractitioner: (practitionerId: number, updateData: any) => void;
  onDelete: () => void;
  setSelectedView: (view: string) => void;
  checkDuration: () => string;
  checkStartTime: () => string;
  setGoRouteModalIsOpen: (isOpen: boolean) => void;
}

const openGoogleMapsStreetView = (practitioner: any) => {
  const address = encodeURIComponent(practitioner.address || '');
  const coordinates = `${practitioner.latitude},${practitioner.longitude}`;
  const query = address || coordinates;
  window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, '_blank');
}

const MeetingModal = ({ isOpen, practitioner, onClose, updatePractitioner, onDelete, setSelectedView, checkDuration, checkStartTime, setGoRouteModalIsOpen }: IMeetingModalProps) => {
  const [startTime, setStartTime] = useState(checkStartTime());
  const [isStartTimeModalOpen, setIsStartTimeModalOpen] = useState(false);
  const [duration, setDuration] = useState<string>(checkDuration() ? checkDuration() : '15 min');
  const [isDurationModalOpen, setIsDurationModalOpen] = useState(false);
  const [isIdentificationCardModalOpen, setIsIdentificationCardModalOpen] = useState(false);
  const { width, height } = useWindowSize();
  const closeMeetingModal = () => {
    onClose();
    const minutes = duration.includes('min')
      ? parseInt(duration)
      : Math.round(parseFloat(duration) * 60);
    updatePractitioner(practitioner.id, {
      start_time: startTime,
      meeting_duration: minutes
    });
    setStartTime('');
    setDuration('15 min');
  }

  const handleIdentificationCardClick = () => {
    store.setCurrentPractitioner(practitioner);
    setIsIdentificationCardModalOpen(true);
  }

  const handleDuration = (duration: string) => {
    // Convert the duration string to minutes
    const minutes = duration.includes('min')
      ? parseInt(duration)
      : Math.round(parseFloat(duration) * 60);
    setDuration(minutes.toString());
  };

  if (!isOpen || !practitioner) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.modalContent}>
          <div className={styles.header}>
            <BlackBackIcon
              className={styles.backButton}
              onClick={closeMeetingModal}
              height={20}
              width={20}
              style={{
                position: 'absolute',
                left: 15,
                paddingRight: 10,
                top: 30
              }}

            />
            <div className={styles.practitionerInfo}>
              <div className={styles.practitionerInfoHeader}>
                <span className={styles.practitionerName}>{practitioner.name}</span>
                <span className={styles.practitionerSpecialty}>{practitioner.specialty}</span>
              </div>
              <IdentificationCardIcon onClick={handleIdentificationCardClick} style={{ cursor: 'pointer', marginRight: '7px' }} />
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.address}>
              {practitioner.address}
              {/*<div onClick={() => openGoogleMapsStreetView(practitioner)}><NavigationArrowIcon stroke={'#8B8B8B'} width={22} height={22} />Navigate</div>*/}
              <div className={styles.navigateButton} onClick={() => setGoRouteModalIsOpen(true)}>
                <NavigationArrowIcon stroke={'#4F7D9C'} width={22} height={22} />NAVIGATE
              </div>                            
            </div>
            <div className={styles.timeWrapper}>
              <div className={styles.timeHeader}>
                <span style={{ fontSize: 12, paddingLeft: 20 }}>
                  Start Time
                </span>
                <span style={{ fontSize: 9, color: "#8B8B8B" }}>
                  If you need to be at the location at this time
                </span>
              </div>
              <div>
                {startTime ? (
                  <div className={styles.time}>
                    <BlueAlarmIcon width={35} height={35} />
                    <span onClick={() => setIsStartTimeModalOpen(true)} style={{ fontSize: 30, color: "#4F7D9C" }}>{startTime}</span>
                    <CloseIcon style={{ marginLeft: 20 }} color="#4F7D9C" width={20} height={20} onClick={() => setStartTime('')} />
                  </div>
                ) : (
                  <div onClick={() => setIsStartTimeModalOpen(true)} className={styles.timeComponent}>
                    <AlarmIcon />
                    <span style={{ fontSize: 14, color: "#8B8B8B" }} >No time set</span>
                  </div>
                )}
                <StartTimeModal
                  isOpen={isStartTimeModalOpen}
                  onClose={() => setIsStartTimeModalOpen(false)}
                  startTime={startTime}
                  setStartTime={setStartTime}
                  setIsStartTimeModalOpen={setIsStartTimeModalOpen}
                />
              </div>
            </div>
            <span style={{ paddingLeft: 20, fontSize: 12 }}>
              Meeting Duration
            </span>
            <div className={styles.duration}>

              <div onClick={() => setIsDurationModalOpen(true)} className={styles.timeComponent}>
                <span style={{ fontSize: 30 }}>
                  {duration.includes('min')
                    ? duration.split(' ')[0]
                    : Number(duration.split(' ')[0]).toString()}
                </span>
                <span style={{ fontSize: 15 }}>
                  {duration.includes('min') ? 'Minutes' : parseFloat(duration) == 1.0 ? 'Hour' : 'Hours'}
                </span>
              </div>
              <DurationModal
                isOpen={isDurationModalOpen}
                onClose={() => {
                  setIsDurationModalOpen(false);
                }}
                duration={duration}
                setDuration={setDuration}
                setIsDurationModalOpen={setIsDurationModalOpen}
              />
            </div>
            <div className={styles.buttonContainer}>
              <Button fontSize={20} fontWeight="700" width="100%" type="outline" color="#E64B3780" textColor="#E64B37" onClick={onDelete}>DELETE MEETING</Button>
            </div>
          </div>
        </div>
      </div>
      {isIdentificationCardModalOpen &&
        ReactDOM.createPortal(
          <div className={styles.baseballCardOverlay}>
            <div
              className={styles.baseballCardModal}
              onClick={e => e.stopPropagation()}
            >
              <div className={styles.baseballCardModalContent} style={{ width: width > 480 ? width * .6 : width * .9, height: height * .8, position: 'relative', paddingTop: "40px", }}>
                <div className={getLeadStateByPractitioner(store.currentPractitioner) ? styles["tinted-border"] : ""}>
                  {getLeadStateByPractitioner(store.currentPractitioner) && (
                    <div className={styles["top-message"]}>
                      {getLeadStateByPractitioner(store.currentPractitioner)}
                    </div>
                  )}
                </div>
                  <BaseballCard backHandler={() => setIsIdentificationCardModalOpen(false)} tab={Tab.SUMMARY} generalNotes={practitioner.general_notes || ''} />
              </div>
            </div>
          </div>,
          document.body
        )
      }
    </div>
  );
};

export default MeetingModal;
